<div [style.height]="params.height" [style.width]="params.width" [class]="params.width? 'flex-col' : 'flex-row'">
  <ng-container *ngIf="params.children">
    <ng-container *ngFor="let panelItem of params.children">
      <app-panel-item class="child" [item]="panelItem"></app-panel-item>
    </ng-container>
  </ng-container>
</div>
